import React, {useEffect, useState} from 'react';
import {CardItem} from "../../shared-components/CardItem";
import Typography from "@mui/material/Typography";
import {IconCaretDownFilled, IconCaretUpFilled} from "@tabler/icons-react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import {CurrencyExchange, Numbers, Receipt} from "@mui/icons-material";
import BarGraph from "../../shared-components/BarGraph";

const Statistics = ({transactions}) => {
    const [numberOfItemsSold, setNumberOfItemsSold] = useState(0);
    const [salesConversionPercent, setSalesConversionPercent] = useState(0);
    const [transactionCount, setTransactionCount] = useState(0);
    const [totalIncome, setTotalIncome] = useState(0);
    const [transactionCountPercent, setTransactionCountPercent] = useState(0);
    const [sumByStand, setSumByStand] = useState([]);
    const [standsMap, setStandsMap] = useState([]);

    useEffect(() => {
        console.log(transactions)

        if (transactions) {
            let numberOfItemsSold = 0;
            let transactionCount = 0;
            let totalIncome = 0;
            let standsMap = new Map();

            transactions.bartender.forEach(bartenderTransaction => {
                numberOfItemsSold += bartenderTransaction.itemsSold.length;
                transactionCount += 1;
                totalIncome += bartenderTransaction.amountDeducted;

                const standId = bartenderTransaction.stand;
                const amount = bartenderTransaction.amountDeducted;

                // If the stand is already in the Map, accumulate the amount
                if (standsMap.has(standId)) {
                    standsMap.set(standId, standsMap.get(standId) + amount);
                } else {
                    standsMap.set(standId, amount); // Initialize if not present
                }
            })
            console.log(standsMap)
            const outputArray = [];
            standsMap.forEach((totalAmount, standId) => {
                outputArray.push({ name: standId, amount: totalAmount });
            });

            setStandsMap([...outputArray]);
            setNumberOfItemsSold(numberOfItemsSold);
            setTransactionCount(transactionCount);
            setTotalIncome(totalIncome);
        }
    }, [transactions])

    return (
        <>
            <Typography variant={'h4'} sx={{marginBottom: 2}}><strong>Štandovi</strong></Typography>

            <Stack spacing={2} direction={'row'}>

                <CardItem
                    icon={<CurrencyExchange/>}
                    title={totalIncome}
                    subtitle={"Ukupan promet"}
                    secondary={<Box sx={{textAlign: "center"}}>
                        <Stack direction={"row"} gap={1} justifyContent={"center"} alignItems={"center"}>
                            {/*<Typography fontWeight={700}*/}
                            {/*            sx={{color: `#000 !important`}}>{transactionCountPercent}</Typography>*/}
                        </Stack>
                        {/*<Typography fontSize={"0.55rem"} color={grey[500]}>in the last hour</Typography>*/}
                    </Box>}
                />

                <CardItem
                    icon={<Numbers/>}
                    title={numberOfItemsSold}
                    subtitle={"Prodatih artikala"}
                    secondary={<Box sx={{textAlign: "center"}}>
                        <Stack direction={"row"} gap={1} justifyContent={"center"} alignItems={"center"}>
                            {/*<Typography fontWeight={700}*/}
                            {/*            sx={{color: `#000 !important`}}>{salesConversionPercent}</Typography>*/}
                        </Stack>
                        {/*<Typography fontSize={"0.55rem"} color={grey[500]}>in the last hour</Typography>*/}
                    </Box>}
                />

                <CardItem
                    icon={<Receipt/>}
                    title={transactionCount}
                    subtitle={"Transakcija"}
                    secondary={<Box sx={{textAlign: "center"}}>
                        <Stack direction={"row"} gap={1} justifyContent={"center"} alignItems={"center"}>
                            {/*<Typography fontWeight={700}*/}
                            {/*            sx={{color: `#000 !important`}}>{transactionCountPercent}</Typography>*/}
                        </Stack>
                        {/*<Typography fontSize={"0.55rem"} color={grey[500]}>in the last hour</Typography>*/}
                    </Box>}
                />
            </Stack>

            <Box sx={{p: 2, pb: 0, textAlign: "center"}}>
                <BarGraph data={standsMap}/>
                <Typography fontWeight={700} fontSize={12} sx={{pb: 2, color: "#a8a6a6"}}>
                    Promet po štandu
                </Typography>
            </Box>


            <Typography variant={'h4'} sx={{marginBottom: 2}}><strong>Kartice korisnika</strong></Typography>
            <Typography variant={'h5'}>Uskoro!</Typography>
        </>
    )
};

export default Statistics;
